module.exports = __webpack_public_path__ + "static/media/10.fe13fd56.png";